import CardMarker from '../../../../../components/CockpitCards/CardMarker';
import Typography from '@mui/material/Typography';
//import LongSubText from './LongSubText';
import LongevityLineHeader from '../../../../../components/TextComps/LongevityLineHeader';
import LongevityLine from '../../../../../components/TextComps/LongevityLine';
import ButtonGene from '../../../../../components/Button/ButtonGene';
import ButtonGeneGreen from '../../../../../components/Button/ButtonGeneGreen';
import DiaInfoLong from './DiaInfoLong';
import DiaDataLong from './DiaDataLong';
import DiaInfoApo from './DiaInfoApo';
import DiaInfoMtor from './DiaInfoMtor';


export default function LongevityCard() {


return(
<>

<CardMarker

  headline = "LONGEVITY" 
  subtext = {"Approximately one-third of the variability in the human lifespan is affected by genetic factors. Longer life spans tend to run in families, which suggests that shared genetics, lifestyle, or both play an important role in determining longevity. Remember that aging is the primary cause of many chronic diseases of later life."}
  
  cardlines = {<> 

<LongevityLineHeader one="GENE" two="VARIANT" three="GT" four="EFFECT" five="INFO" six="DETAILS" />

    <LongevityLine marker={<ButtonGeneGreen name="FOXO3" action={() => {"do something"}} />} variant="rs13220810" genotype="T/C" effect={<Typography sx={{color:'traffic.green', fontWeight: 600}}>Advantage</Typography>} icon_1 = {<DiaInfoLong />} icon_2 = {<DiaDataLong />} />
    <LongevityLine marker={<ButtonGeneGreen name="APOE" action={() => {"do something"}} />} variant="rs7412" genotype="e2/e3" effect={<Typography sx={{color:'traffic.green', fontWeight: 600}}>Advantage</Typography>} icon_1 = {<DiaInfoApo />} icon_2 = {<DiaDataLong />} />
    <LongevityLine marker={<ButtonGene name="TERT" action={() => {"do something"}} />} variant="" genotype="" effect={<Typography sx={{fontWeight: 600}}>Neutral</Typography>} icon_1 = {<DiaInfoApo />} icon_2 = {<DiaDataLong />} />
    <LongevityLine marker={<ButtonGene name="SIRT1-7" action={() => {"do something"}} />} variant="" genotype="" effect={<Typography sx={{fontWeight: 600}}>Neutral</Typography>} icon_1 = {<DiaInfoApo />} icon_2 = {<DiaDataLong />} />
    <LongevityLine marker={<ButtonGeneGreen name="MTOR" action={() => {"do something"}} />} variant="rs2295080" genotype="G/T" effect={<Typography sx={{color:'traffic.green', fontWeight: 600}}>Advantage</Typography>} icon_1 = {<DiaInfoMtor />} icon_2 = {<DiaDataLong />} />
   </>
  }
/>

</>
)
}

